import { useState, useEffect } from 'react';

/**
 * ¿El viewport es de ancho móvil?
 *
 * Los componentes usan estilos inline, así que no hay media queries donde
 * apoyarse: el breakpoint tiene que resolverse en JS. Se escucha `resize` para
 * que rotar el teléfono o redimensionar la ventana reacomode el layout.
 */
export const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
};
